import { Link } from "react-router-dom";

interface NewsCardProps {
  news: {
    id: string;
    title: string;
    cover: string;
    summary: string;
    category: string;
    publishedAt: string;
  };
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ news, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/detail/${news.id}`}
        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors wf-fade-up"
      >
        <div className="relative w-full sm:w-56 shrink-0 aspect-[8/5] rounded-md overflow-hidden bg-background-200">
          <img
            src={news.cover}
            alt={`${news.title} 资讯配图`}
            title={`${news.title} - 火狼动漫网动漫资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 text-xs font-medium whitespace-nowrap">
              {news.category}
            </span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">{news.publishedAt}</span>
          </div>
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors wf-line-clamp-2">
            {news.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed wf-line-clamp-2">{news.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${news.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors wf-fade-up"
    >
      <div className="relative w-full aspect-[8/5] overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`${news.title} 资讯配图`}
          title={`${news.title} - 火狼动漫网动漫资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-700/90 text-background-50 text-xs font-medium whitespace-nowrap">
          {news.category}
        </span>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors wf-line-clamp-2 leading-relaxed">
          {news.title}
        </h3>
        <p className="mt-2 text-xs text-foreground-600 leading-relaxed wf-line-clamp-2">{news.summary}</p>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-time-line"></i>
          </span>
          <span>{news.publishedAt}</span>
        </div>
      </div>
    </Link>
  );
}